import React from 'react';

export default function useToggle(isOn = false) {
  const [state, setState] = React.useState<{ on: boolean; off: boolean }>({
    on: isOn,
    off: !isOn,
  });

  function toggle() {
    setState((s) => ({
      on: !s.on,
      off: !s.off,
    }));
  }

  function close() {
    setState((s) => (s.on ? { on: false, off: true } : s));
  }

  function open() {
    setState((s) => (s.off ? { on: true, off: false } : s));
  }

  React.useEffect(() => {
    return () => {
      setState({
        on: false,
        off: true,
      });
    };
  }, []);

  return {
    toggle,
    opened: state.on,
    closed: state.off,
    open,
    close,
  };
}
